import type { ReceiptTemplate } from '../schema';

export const womensMedicalTemplate: ReceiptTemplate = {
  id: 'abortion',
  name: 'Abortion Receipt',
  brand: "WOMEN'S MEDICAL CENTER",
  description: "Medical center receipt template for women's health services",
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'wmc-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'WOMENS MEDICAL CENTER',
        businessNameFontSize: 14,
        addressLines: [
          '1200 AVENUE',
          'MONSTERVILLE, CA 94608',
          '5105550127',
        ],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'wmc-cashier',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Cashier: Medico Corp\nTransaction 000047',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'wmc-card-sale',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        labelAlignment: 'left',
        lines: [
          { id: 'wmc-total', label: 'TOTAL', value: '650.00', isBold: false, isLarge: false },
          { id: 'wmc-debit', label: 'DEBIT CARD SALE', value: '650.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'wmc-card-details',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '23-Jun-2025 2:15:42P\n$650.00 | Method: EMV\nUS DEBIT XXXXXXXXXXXX4144\nReference ID: 30851062847\nAuth ID: 004792\nMID: *******1847\nAID: A0000000980840\nAthNtwkNm: INTERLINK\nRIInd: DEBIT\nPIN VERIFIED',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'wmc-online',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Online: https://clover.com/p\n/MWK8XVNP47RQZ',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'wmc-reprint',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '*** REPRINT ***',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'wmc-payment-id',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Payment MWK8XVNP47RQZ',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
